var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6BE00",
    fillRule: "nonzero",
    d: "M15.157 10.742c-.4-.395-.876-.609-1.37-.609-.493 0-.964.21-1.365.605l-.106.102c-.391.387-.792.782-1.183 1.187a5.178 5.178 0 0 0-.222-.111 5.393 5.393 0 0 1-.507-.272c-1.187-.746-2.28-1.742-3.338-3.04-.507-.622-.863-1.177-1.112-1.733.347-.333.685-.68 1.018-1.013L7.23 5.6c.84-.844.836-1.933-.004-2.782l-.76-.76-.33-.33-.35-.35c-.254-.254-.512-.516-.774-.774C4.612.21 4.136 0 3.642 0c-.493 0-.964.209-1.364.604-.191.187-.378.378-.565.565-.267.271-.542.551-.822.813-.525.498-.818 1.13-.876 1.871-.089 1.165.236 2.218.529 3.005.662 1.778 1.671 3.462 3.085 5.146a19.201 19.201 0 0 0 6.317 4.943c1.338.649 2.485.982 3.606 1.044.084.005.164.009.244.009.952 0 1.734-.333 2.325-.996.254-.28.52-.542.81-.822.142-.142.293-.284.44-.43.835-.845.84-1.934.008-2.77-.742-.769-1.493-1.52-2.222-2.24z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.72c829bf81d2737985ba2bfaec4ce6cd.svg";
export { ForwardRef as ReactComponent };